"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return Workflow;
    }
});
let Workflow = class Workflow {
    static async get(..._args) {
        return null;
    }
    static async list(..._args) {
        return [];
    }
    static async insert(..._args) {
        return null;
    }
    static async update(..._args) {
        return null;
    }
    static async delete(..._args) {
        return null;
    }
    static async findByTrigger(..._args) {
        return [];
    }
    constructor(_workflow){
        Object.assign(this, _workflow);
    }
};
